"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditionTabs = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var options = [{
  label: "Descripción",
  key: "description"
}, {
  label: "Ficha técnica",
  key: "datasheet"
}, {
  label: "Imágenes",
  key: "images"
}];

var EditionTabs = function EditionTabs(props) {
  var _useState = (0, _react.useState)("description"),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      section = _useState2[0],
      setSection = _useState2[1];

  function changeSection() {
    var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "description";
    setSection(section);
    if (props.getSection) props.getSection(section);
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: options.map(function (_ref, i) {
      var label = _ref.label,
          key = _ref.key;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Button, {
        onClick: function onClick() {
          return changeSection(key);
        },
        isActive: section === key,
        children: label
      }, key);
    })
  });
};

exports.EditionTabs = EditionTabs;